/**
 * Bottom toolbar shown on mobile/iPhone for primary navigation.
 * Built with safe-area-inset support so it sits nicely above the home bar.
 */

import { Link, useRouterState } from "@tanstack/react-router";
import { Archive, Bell, Lightbulb, Search } from "lucide-react";

// Four items so the center-docked FAB lands in the gap between Reminders and
// Search instead of obscuring a middle button. Settings lives in the header.
const items = [
  { to: "/", icon: Lightbulb, label: "Notes" },
  { to: "/reminders", icon: Bell, label: "Reminders" },
  { to: "/search", icon: Search, label: "Search" },
  { to: "/archive", icon: Archive, label: "Archive" },
];

export function MobileToolbar() {
  const route = useRouterState({ select: (s) => s.location.pathname });

  return (
    <div className="mobile-toolbar app-chrome lg:hidden" role="navigation" aria-label="Primary">
      {items.map((it) => {
        const Icon = it.icon;
        const active = route === it.to || (it.to !== "/" && route.startsWith(it.to));
        return (
          <Link
            key={it.to}
            to={it.to}
            aria-label={it.label}
            aria-current={active ? "page" : undefined}
            className="flex flex-col items-center justify-center"
          >
            <Icon className="w-5 h-5" />
            <span>{it.label}</span>
          </Link>
        );
      })}
    </div>
  );
}
